import React from "react";
import Seo from "../components/seo";
import BaseLayout from "../containers/BaseLayout";
import Policy from "../sections/Privacy/policy";
import '../globalStyles.css';

const PrivacyPolicy = () => {
    return (
        <BaseLayout>
            <Seo title={"Privacy Policy"} />
            <Policy />
        </BaseLayout>
    );
};

export default PrivacyPolicy;